import { render, staticRenderFns } from "./LostReasonModal.vue?vue&type=template&id=87fb6b6c&"
import script from "./LostReasonModal.vue?vue&type=script&lang=js&"
export * from "./LostReasonModal.vue?vue&type=script&lang=js&"
import style0 from "./LostReasonModal.vue?vue&type=style&index=0&id=87fb6b6c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports